import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 py-8 bg-[#050810] border-t border-[#D4A843]/30" data-id="element-22">
      <div className="max-w-6xl mx-auto text-center" data-id="element-23">
        <p className="text-gray-400 text-sm" data-id="element-24">
          © 2026 Liberación Miofascial Pro. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}